var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles } from "../../styles/index";
import React from 'react';
import { Popup } from "../Popup/Popup";
import { ColorButton } from "./ColorButton";
import { getColorTableWithTransparent, getOpacityColorTable, NormalColorTable } from "./utils/ColorUtils";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(1),
    },
    row: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
}); }, { name: 'SnColorPicker' });
export var ColorPicker = React.memo(function (props) {
    var open = props.open, onClick = props.onClick, onClose = props.onClose, anchorEl = props.anchorEl, currentColor = props.currentColor, _a = props.colorTable, colorTable = _a === void 0 ? NormalColorTable : _a, useTransparent = props.useTransparent, useOpacity = props.useOpacity, _b = props.placement, placement = _b === void 0 ? 'bottom-start' : _b, _c = props.boundariesElement, boundariesElement = _c === void 0 ? 'scrollParent' : _c;
    var classes = useStyles();
    var displayColorTable = (function () {
        var opacityOrNormalColorTable = useOpacity ? getOpacityColorTable(colorTable) : colorTable;
        return useTransparent ? getColorTableWithTransparent(opacityOrNormalColorTable) : opacityOrNormalColorTable;
    })();
    var colorButtonTable = displayColorTable.map(function (row) {
        return row.map(function (item) { return ({
            iconColor: item,
            active: item === currentColor,
            onClick: function () {
                onClick(item);
                onClose();
            },
        }); });
    });
    return (React.createElement(Popup, { className: classes.root, open: open, anchorEl: anchorEl, onClickAway: onClose, placement: placement, boundariesElement: boundariesElement }, colorButtonTable.map(function (row, rowIndex) { return (React.createElement("div", { key: rowIndex, className: classes.row }, row.map(function (item, index) { return (React.createElement(ColorButton, __assign({ key: index }, item))); }))); })));
});
